var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.013 15.9041V2.00009C14.013 2.00009 13.984 1.99609 13.957 1.99609C6.242 1.99609 0 8.25009 0 15.9651C0 23.6821 6.261 29.8861 13.976 29.8861C21.679 29.8861 27.931 23.9041 27.951 15.9041H14.013Z",
    fill: "#32589F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9517 13.904C29.9517 13.904 29.9277 13.929 29.9277 13.916C29.9277 6.228 24.0137 0.044 16.0137 0V13.903L29.9517 13.904Z",
    fill: "#32589F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquity);
export default __webpack_public_path__ + "static/media/equity.b132c7908c28d7cacf61dc63f83f3004.svg";
export { ForwardRef as ReactComponent };